/**
 * @module shared/account-types
 * Canonical account type definitions used by the web client.
 */

/** @typedef {'Bank Account'|'Credit Card'|'Loan'|'Investment Account'|'Pension'|'Points/Miles'|'Prepaid Card'|'Real Estate'|'Store Credit'} AccountType */

export const ACCOUNT_TYPES = Object.freeze([
	'Bank Account',
	'Credit Card',
	'Loan',
	'Investment Account',
	'Pension',
	'Points/Miles',
	'Prepaid Card',
	'Real Estate',
	'Store Credit'
]);

export const PORTFOLIO_TYPES = Object.freeze([
	'Investment Account',
	'Pension',
	'Real Estate'
]);

const LIABILITY_TYPES = Object.freeze(['Credit Card', 'Loan']);

/**
 * @param {string} accountType
 * @returns {boolean}
 */
export function isPortfolioType(accountType) {
	return PORTFOLIO_TYPES.includes(accountType);
}

/**
 * @param {string} accountType
 * @returns {boolean}
 */
export function isLiabilityType(accountType) {
	return LIABILITY_TYPES.includes(accountType);
}
